const extractColorsByType = (type, config) => {
  var _a, _b;
  if (!config.color_config) return "";
  const colorConfig = config.color_config.find((color) => color.type === type);
  if (!colorConfig) return "";
  return (_b = (_a = colorConfig.icon_background_color) == null ? void 0 : _a.background_color) == null ? void 0 : _b.hex;
};
export {
  extractColorsByType
};
